document.addEventListener("DOMContentLoaded", function () {
    const animatedElements = document.querySelectorAll("[data-animation]")

    // data-delay değerlerini CSS değişkeni olarak ayarla
    animatedElements.forEach(element => {
        const delay = element.getAttribute("data-delay") || 0
        element.style.setProperty("--delay", delay)
    })

    const checkVisibility = () => {
        animatedElements.forEach(element => {
            const elementTop = element.getBoundingClientRect().top
            const elementBottom = element.getBoundingClientRect().bottom

            // Element görünür alana geldi mi?
            if (elementTop < window.innerHeight && elementBottom > 0) {
                const animationType = element.getAttribute("data-animation")

                // Animasyonu uygula
                element.classList.add(`animate-${animationType}`)
            }
        })
    }

    // Sayfa yüklendiğinde ve kaydırma yapıldığında kontrol et
    window.addEventListener("scroll", checkVisibility)
    checkVisibility() // Sayfa yüklendiğinde ilk kontrol
})
